// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xlargeOnConfined-text-27c753a7"};